import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
export const HeaderActions = ({ children }) => {
    const [domReady, setDomReady] = useState(false);
    useEffect(() => {
        setDomReady(true);
    }, []);
    return domReady && createPortal(children, document.querySelector('.global-header--actions'));
};
